import { Box, Button, HStack, Td, Th, Tr, useToast } from "@chakra-ui/react";
import TablePageTemplate from "components/Templates/TablePage";
import { Breadcrumb } from "layouts/LayoutDefault/Breadcrumb";
import { useCallback, useEffect, useState } from "react";
import { useAppDispatch, useTypedSelector } from "store/hooks";
import { getRoles } from "store/modules/users/actions/getRoles";
import { getUsersPaginated } from "store/modules/users/actions/getUsersPaginated";
import { linkerRole } from "store/modules/users/actions/linkerRole";

const Users = () => {
  const [search, setSearch] = useState('');
  const [page, setPage] = useState(0);
  const dispatch = useAppDispatch();
  const toast = useToast();

  const { successPayload: users, isRequesting: loadingUsers } =
    useTypedSelector((state) => state.users.getUsersPaginated);

  const { successPayload: roles, isRequesting: loadingRoles } =
    useTypedSelector((state) => state.users.getRoles);

  const { isRequesting: loadingVincular } = useTypedSelector(
    (state) => state.users.linkerRole
  );

  const lastRequest = useTypedSelector(
    (state) => state.users.getUsersPaginated.lastRequest
  );

  const fetchData = useCallback(
    (pageIndex: number, pageSize: number, search: string) => {
      dispatch(
        getUsersPaginated({
          pageIndex,
          pageSize,
          search,
        })
      );
    },
    [dispatch]
  );

  useEffect(() => {
    fetchData(page, 5, search);
  }, [fetchData, page, search]);

  useEffect(() => {
    dispatch(getRoles());
  }, [dispatch]);

  const handleVincularPerfil = (idUsuario: string, role: string) => {
    dispatch(
      linkerRole({
        idUsuario,
        role,
        onSuccess() {
          toast({
            status: "success",
            description: "Perfil atualizado com sucesso!",
          });
          if (lastRequest) dispatch(getUsersPaginated(lastRequest));
        },
      })
    );
  };

  return (
    <Box p={8}>
      <Breadcrumb paths={[{ name: "Usuários" }]} />
      <TablePageTemplate
        title="Usuários"
        onSearch={setSearch}
        tableHeader={
          <Tr>
            <Th>Nome</Th>
            <Th>Email</Th>
            <Th></Th>
          </Tr>
        }
        renderTableItem={(user) => (
          <Tr>
            <Td>{user.nome}</Td>
            <Td>{user.email}</Td>

            <HStack as={Td}>
              {roles.map((role) => (
                <Button
                  key={role.id}
                  size="sm"
                  isLoading={loadingVincular}
                  bgColor={
                    user.roles.find((x) => x === role.id) ? "blue.500" : ""
                  }
                  onClick={() => handleVincularPerfil(user.id, role.id)}
                >
                  {role.name}
                </Button>
              ))}
            </HStack>
          </Tr>
        )}
        data={users.items}
        onPageChange={setPage}
        pageProps={{
          index: page,
          pageSize: users.pageSize,
          totalItems: users.totalCount,
          hasNextPage: users.hasNextPage,
          hasPreviousPage: users.hasPreviousPage,
          isLoading: loadingUsers && loadingRoles,
        }}
      />
    </Box>
  );
};

export default Users;
